import React, { Component } from 'react';
import { connect } from "react-redux";
import _ from 'lodash';
import  TestDetailsOrder  from './TestDetailsOrder';
import   TestDetailsTest  from  './TestDetailsTest';
import styles from './TestStyle';
import { WithStyles, createStyles, Typography, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';



//@ts-ignore
interface OrderNotesProps extends WithStyles<typeof styles> {
    classes: any,
    firstName: string,
    lastName: string,
    orderNote: any,
    subject: string,
    test: any,
    goal: any,
    testName: string,
    type: any,
    questionTypes: any,
    orderNoteAttachments: string[];
}



class OrderNotes extends Component<OrderNotesProps >{
    constructor(props: OrderNotesProps) {
        super(props);
    }


    render() {
        const { classes, firstName, lastName, orderNote, subject, test, goal, testName, type, questionTypes, orderNoteAttachments } = this.props;
        return (
            <>
                <TestDetailsTest classes = {classes} test ={test} subject={subject} goal={goal} testName={testName} type={type} questionTypes={questionTypes}/>
                <TestDetailsOrder classes = {classes} firstName = {firstName} lastName = {lastName} orderNote={orderNote} orderNoteAttachments={orderNoteAttachments} />
            </>
        );

    }

}

// @ts-ignore
export default withStyles(styles)(OrderNotes);
